var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGrid = function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.82932 2.35229H4.62478C5.44065 2.35229 6.10205 3.01369 6.10205 3.82957V4.62502C6.10205 5.4409 5.44065 6.10229 4.62478 6.10229H3.82932C3.01345 6.10229 2.35205 5.4409 2.35205 4.62502V3.82957C2.35205 3.01369 3.01345 2.35229 3.82932 2.35229Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60205 2.35229H10.3975C11.2134 2.35229 11.8748 3.01369 11.8748 3.82957V4.62502C11.8748 5.4409 11.2134 6.10229 10.3975 6.10229H9.60205C8.78618 6.10229 8.12478 5.4409 8.12478 4.62502V3.82957C8.12478 3.01369 8.78618 2.35229 9.60205 2.35229Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1702 2.35229H15.3748C14.5589 2.35229 13.8975 3.01369 13.8975 3.82957V4.62502C13.8975 5.4409 14.5589 6.10229 15.3748 6.10229H16.1702C16.9861 6.10229 17.6475 5.4409 17.6475 4.62502V3.82957C17.6475 3.01369 16.9861 2.35229 16.1702 2.35229Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.82932 8.12502H4.62478C5.44065 8.12502 6.10205 8.78642 6.10205 9.60229V10.3977C6.10205 11.2136 5.44065 11.875 4.62478 11.875H3.82932C3.01345 11.875 2.35205 11.2136 2.35205 10.3977V9.60229C2.35205 8.78642 3.01345 8.12502 3.82932 8.12502Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3975 8.12502H9.60205C8.78618 8.12502 8.12478 8.78642 8.12478 9.60229V10.3977C8.12478 11.2136 8.78618 11.875 9.60205 11.875H10.3975C11.2134 11.875 11.8748 11.2136 11.8748 10.3977V9.60229C11.8748 8.78642 11.2134 8.12502 10.3975 8.12502Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3748 8.12502H16.1702C16.9861 8.12502 17.6475 8.78642 17.6475 9.60229V10.3977C17.6475 11.2136 16.9861 11.875 16.1702 11.875H15.3748C14.5589 11.875 13.8975 11.2136 13.8975 10.3977V9.60229C13.8975 8.78642 14.5589 8.12502 15.3748 8.12502Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62478 13.8977H3.82932C3.01345 13.8977 2.35205 14.5591 2.35205 15.375V16.1705C2.35205 16.9864 3.01345 17.6477 3.82932 17.6477H4.62478C5.44065 17.6477 6.10205 16.9864 6.10205 16.1705V15.375C6.10205 14.5591 5.44065 13.8977 4.62478 13.8977Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60205 13.8977H10.3975C11.2134 13.8977 11.8748 14.5591 11.8748 15.375V16.1705C11.8748 16.9864 11.2134 17.6477 10.3975 17.6477H9.60205C8.78618 17.6477 8.12478 16.9864 8.12478 16.1705V15.375C8.12478 14.5591 8.78618 13.8977 9.60205 13.8977Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1702 13.8977H15.3748C14.5589 13.8977 13.8975 14.5591 13.8975 15.375V16.1705C13.8975 16.9864 14.5589 17.6477 15.3748 17.6477H16.1702C16.9861 17.6477 17.6475 16.9864 17.6475 16.1705V15.375C17.6475 14.5591 16.9861 13.8977 16.1702 13.8977Z",
    fill: "white"
  })));
};
export default SvgGrid;